import React, { Component } from "react";
import { Link } from "react-router-dom";
import MapLogo from "./map";
import phoneFooter from "../res/phoneFooter.png";
import mailFooter from "../res/mailFooter.png";
import homeFooter from "../res/home.png";
import AboutHeader from "./shared/aboutHeader";

class Branches extends Component {
  render() {
    return (
      <div>
        <div className="thumbnail" />
        <AboutHeader active="branches" />
        <div
          className="tab-pane fade show"
          id="nav-branches"
          role="tabpanel"
          aria-labelledby="nav-branches-tab"
        >
          <div className="container ">
            <h1 className="currentPageTitle mt-3 col-12 col-md-12 pl-04">
              BRANCHES
            </h1>
          </div>
          <div className="fluid-container highlight">
            <div className="container">
              <div className="row">
                <div className="col-12 row">
                  <div
                    className="col-12"
                    style={{ margin: 0, fontSize: 40, textAlign: "center" }}
                  >
                    <MapLogo
                      city="Tbilisi"
                      link={"https://goo.gl/maps/tZbTw5GkF5W5GaLi9"}
                    ></MapLogo>
                    <div className="column">
                      <span className="color-emg" style={{ margin: 0 }}>
                        HEAD OFFICE: TBILISI
                      </span>
                      <br />
                      <p style={{ margin: 0, fontSize: 25 }}>
                        47 A. Kazbegi Str. 0101 Tbilisi, Georgia
                      </p>
                      <p>
                        <img alt="phone" className="p-1 " src={homeFooter} />
                        <a href="tel:+995322151000" className="branches">
                          (+995) 032 2 15 10 00
                        </a>{" "}
                        /
                        <img alt="phone" className="p-1 " src={phoneFooter} />
                        <a href="tel:+995591599292" className="branches">
                          (+995) 591 59 92 92
                        </a>
                        <img alt="mail" className="p-1" src={mailFooter} />
                        <a href="mailto:info@emg.ge" className="branches">
                          info@emg.ge
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="container p-5"></div>
                  <div className="col-6 col-md-6 row">
                    <MapLogo
                      city="Telavi"
                      link={"https://map.google.com"}
                    ></MapLogo>
                    <div className="column mt-2">
                      <h3 className="color-emg">Telavi</h3>
                      <p> Rustaveli street #86</p>
                      {/* <p>
                        <img alt="mail" className="pr-1" src={mailFooter} />
                        <a href="mailto:imereti@emg.ge">imereti@emg.ge</a>
                      </p> */}
                    </div>
                  </div>

                  <div className="col-6 col-md-6 row">
                    <MapLogo
                      city="Kutaisi"
                      link={"https://map.google.com"}
                    ></MapLogo>{" "}
                    <div className="column mt-2">
                      <h3 className="color-emg">KUTAISI</h3>
                      <p>Tamar mefe street #43</p>
                      {/* <p>
                        <img alt="mail" className="pr-1" src={mailFooter} />
                        <a href="mailto:imereti@emg.ge">imereti@emg.ge</a>
                      </p> */}
                    </div>
                  </div>
                  <div className="col-6 col-md-6 row">
                    <MapLogo
                      city="Chiatura"
                      link={"https://map.google.com"}
                    ></MapLogo>{" "}
                    <div className="column mt-2 ">
                      <h3 className="color-emg">CHIATURA</h3>
                      <p>5 Ninoshvili Str</p>
                      {/* <p>
                        <img alt="mail" className="pr-1" src={mailFooter} />
                        <a href="mailto:imereti@emg.ge">imereti@emg.ge</a>
                      </p> */}
                    </div>
                  </div>
                  <div className="col-6 col-md-6 row">
                    <MapLogo
                      city="Kutaisi"
                      link={"https://map.google.com"}
                    ></MapLogo>{" "}
                    <div className="column mt-2 ">
                      <h3 className="color-emg">Kutaisi</h3>
                      <p>Rustaveli avenue #82-84</p>
                      {/* <p>
                        <img alt="mail" className="pr-1" src={mailFooter} />
                        <a href="mailto:imereti@emg.ge">imereti@emg.ge</a>
                      </p> */}
                    </div>
                  </div>
                  <div className="col-6 col-md-6 row">
                    <MapLogo
                      city="Telavi"
                      link={"https://map.google.com"}
                    ></MapLogo>{" "}
                    <div className="column mt-2 ">
                      <h3 className="color-emg">Telavi</h3>
                      <p>61 Aghmashenebeli street</p>
                      {/* <p>
                        <img alt="mail" className="pr-1" src={mailFooter} />
                        <a href="mailto:imereti@emg.ge">imereti@emg.ge</a>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Branches;
